import React from 'react';
import { Box } from '@mui/material';
import { InvoiceDetailsData } from '../../models/Invoice';
import { InvoiceDetailsDialogTitle } from '../shared/Typography/InvoiceDetailsDialogTitle';
import { useTranslation } from 'react-i18next';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';
import { ErrorTypography } from '../styled/ErrorTypography';
import { InvoiceProductsTableRow } from './InvoiceProductsTableRow';
import { INVOICE_PRODUCTS_HEAD_CELLS } from '../../utils/constans/tableHeads/invoicesTableHead';
import { GeneralTable } from '../shared/Table/GeneralTable';

const InvoiceProducts: React.FC<{
    products: InvoiceDetailsData[];
    isLoading: boolean;
    isError: boolean;
}> = (props) => {
    const { products, isError, isLoading } = props;
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS',
    });

    const tableHeadSettings = {
        translateNs: 'invoices',
        translatePrefix: 'INVOICE_DETAILS.TABLE_HEAD',
        selectable: false,
        headContent: INVOICE_PRODUCTS_HEAD_CELLS,
    };

    const filterTerm = (search) => {
        return products.filter((elem) => {
            return (
                elem.description.includes(search.toLowerCase()) ||
                elem.lineObjectNumber.includes(search.toLowerCase())
            );
        });
    };

    const tableToolbarSettings = {
        translateNs: 'invoices',
        translatePrefix: 'INVOICES.TABLE_TOOLBAR',
    };

    const setTable = () => {
        switch (true) {
            case isLoading:
                return <TableLoadingLayout />;
            case isError:
                return <ErrorTypography errorCode={'INVOICE_DETAILS_ERROR'} />;
            case !isLoading && products.length > 0:
                return (
                    <GeneralTable<InvoiceDetailsData, InvoiceDetailsData>
                        fullList={products}
                        rowComponent={InvoiceProductsTableRow}
                        filterTerm={filterTerm}
                        defaultOrderBy={'description'}
                        selectHandleId={'description'}
                        tableHeadSettings={tableHeadSettings}
                        tableToolbarSettings={tableToolbarSettings}
                        // forceRefresh={forceRefresh}
                        isLoading={isLoading}
                    />
                );
            default:
                return <ErrorTypography errorCode={'INVOICE_DETAILS_ERROR'} />;
        }
    };

    return (
        <Box sx={{ paddingTop: '20px' }}>
            <InvoiceDetailsDialogTitle>
                {t('PRODUCTS_TITLE')}
            </InvoiceDetailsDialogTitle>
            {setTable()}
        </Box>
    );
};

export default InvoiceProducts;
